import * as React from "react";

import { styled } from "@mui/material";
import { green } from "@mui/material/colors";

import { getEnvironment } from "../../services/utils/environment";

const ENV_MAP: { [key: string]: string } = {
  local: "local",
  development: "dev",
  staging: "stage",
};

const BadgeDiv = styled("div")<{ envLabel: string }>(({ theme, envLabel }) => ({
  ":before": {
    content: `"${envLabel}"`,
    zIndex: 1,
    overflow: "hidden",
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    textTransform: "uppercase",
    textAlign: "center",
    lineHeight: "20px",
    transform: "rotate(315deg)",
    width: 120,
    display: "block",
    background: green[800],
    position: "relative",
    top: 35,
    left: -35,
    marginTop: -20,
    clipPath: "polygon(120px 20px, 90px -10px, 30px -10px, 0px 20px, 10px 30px, 110px 30px)",
  },
}));

const EnvironmentBadge: React.FC<{ envOverride?: string }> = ({ envOverride }) => {
  const envLabel = ENV_MAP[envOverride || getEnvironment()];
  return <>{envLabel && <BadgeDiv envLabel={envLabel} />}</>;
};

export const exportForTesting = {
  getEnvironment,
};

export default EnvironmentBadge;
